/* A key cap: outlined like a tag, in the body face (keys are not identifiers). */
.kbd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 var(--space-1);
  border: 1px solid var(--border);
  border-radius: var(--radius-tag);
  background: var(--paper);
  color: var(--graphite);
  font: var(--t-micro);
  font-weight: 600;
  white-space: nowrap;
}

/* Touch screens: no keyboard to press the keys on, so the hint is noise. */
@media (hover: none), (pointer: coarse) {
  .kbd:not([data-persistent]) {
    display: none;
  }
}
